
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class ImagePreview extends Vue {
  @Prop({ default: false }) visible!: boolean;
  @Prop({ default: () => [] }) images!: string[];
  @Prop({ default: 0 }) startPosition!: number;

  currentIndex = 0;
  
  // 缩放相关状态
  scale = 1;
  lastScale = 1;
  pos = { x: 0, y: 0 };
  startPos = { x: 0, y: 0 };
  isDragging = false;
  startDistance = 0;
  lastClickTime = 0; // 用于模拟双击（如果需要）

  get imageStyle() {
    return {
      transform: `translate(${this.pos.x}px, ${this.pos.y}px) scale(${this.scale})`,
      transition: this.isDragging ? 'none' : 'transform 0.3s ease',
    };
  }

  @Watch('visible')
  onVisibleChange(val: boolean) {
    if (val) {
      this.currentIndex = this.startPosition;
      this.resetZoom();
      document.body.style.overflow = 'hidden'; // 禁止背景滚动
    } else {
      document.body.style.overflow = '';
    }
  }

  @Watch('currentIndex')
  onIndexChange() {
    this.resetZoom();
  }

  resetZoom() {
    this.scale = 1;
    this.lastScale = 1;
    this.pos = { x: 0, y: 0 };
    this.startPos = { x: 0, y: 0 };
    this.isDragging = false;
  }

  // 双击放大/缩小
  onDblClick(e: MouseEvent) {
    if (this.scale > 1) {
      this.resetZoom();
    } else {
      this.scale = 2;
      // 可选：以点击位置为中心放大
      // 简单起见，这里先居中放大
    }
  }

  // 触摸开始
  onTouchStart(e: TouchEvent) {
    if (e.touches.length === 1) {
      // 单指操作：拖拽或准备双击
      const touch = e.touches[0];
      this.startPos = {
        x: touch.clientX - this.pos.x,
        y: touch.clientY - this.pos.y,
      };
      
      // 模拟双击（部分移动端浏览器不支持 dblclick 事件）
      const now = Date.now();
      if (now - this.lastClickTime < 300) {
        this.onDblClick(e as unknown as MouseEvent);
        this.lastClickTime = 0;
        return;
      }
      this.lastClickTime = now;
      
      if (this.scale > 1) {
        this.isDragging = true;
      }
    } else if (e.touches.length === 2) {
      // 双指操作：缩放
      this.isDragging = true; // 允许在缩放时调整
      this.startDistance = this.getDistance(e.touches);
      this.lastScale = this.scale;
    }
  }

  // 触摸移动
  onTouchMove(e: TouchEvent) {
    e.preventDefault(); // 防止滚动页面
    if (e.touches.length === 1 && this.scale > 1) {
      // 拖拽
      const touch = e.touches[0];
      this.pos = {
        x: touch.clientX - this.startPos.x,
        y: touch.clientY - this.startPos.y,
      };
    } else if (e.touches.length === 2) {
      // 缩放
      const currentDistance = this.getDistance(e.touches);
      if (this.startDistance > 0) {
        const ratio = currentDistance / this.startDistance;
        this.scale = Math.max(1, this.lastScale * ratio); // 限制最小缩放为 1
      }
    }
  }

  // 触摸结束
  onTouchEnd(e: TouchEvent) {
    this.isDragging = false;
    if (this.scale < 1) {
      this.scale = 1;
      this.pos = { x: 0, y: 0 };
    }
    // 边界检查（可选，防止拖出可视区域）
  }

  // 计算双指距离
  getDistance(touches: TouchList) {
    const dx = touches[0].clientX - touches[1].clientX;
    const dy = touches[0].clientY - touches[1].clientY;
    return Math.sqrt(dx * dx + dy * dy);
  }

  prev() {
    this.currentIndex =
      (this.currentIndex - 1 + this.images.length) % this.images.length;
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
  }

  close() {
    this.$emit('update:visible', false);
    this.$emit('close');
  }
}
